import React from 'react'
import Select from "react-select";


const YearSelector = ({ selectedYear, onChange }) => {
    const currentYear = new Date().getFullYear();
    const years = [];
  
    for (let year = 2000; year <= currentYear; year++) {
      years.push(year);
    }
    
    // Reverse to show recent years first (current year at top)
    const sortedYears = years.reverse();
  
  return (
    <Select
    placeholder="Year:"
    // defaultValue={}
    onChange={onChange}
    options={sortedYears?.map((year) => ({
      label: year,
      value: year,
    }))}
    loadingMessage={() => "Please wait, filterby is loading..."}
    styles={{
      container: (base) => ({
        ...base,
        border: "1px solid",
        borderRadius: "15px",
      }),
      control: (base) => ({
        ...base,
        borderRadius: "15px",
      }),
    }}
  />

  )
}

export default YearSelector